"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddNoteModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _wbmInputs = require("wbm-inputs");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AddNoteModal = exports.AddNoteModal = function AddNoteModal(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _React$useState = _react["default"].useState(props.inputVal),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputVal = _React$useState2[0],
    setInputVal = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(props.charRemain || 100),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    charLeft = _React$useState4[0],
    setCharLeft = _React$useState4[1];
  var charRemaining = function charRemaining(_char) {
    return (props.charRemain || 100) - _char.length;
  };
  var handleActionItem = function handleActionItem() {
    props.saveNote(inputVal);
    props.onClick();
    setCharLeft(charRemaining(inputVal));
  };
  var handleChange = function handleChange(e) {
    if (charRemaining(e) >= 0) {
      setInputVal(e);
      setCharLeft(charRemaining(e));
    }
  };
  var focusClose = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (focusClose.current) {
      focusClose.current.focus();
    }
  }, [focusClose]);
  (0, _react.useEffect)(function () {
    if (props.inputVal && charRemaining(props.inputVal) >= 0) {
      setCharLeft(charRemaining(props.inputVal));
    }
  }, [props.inputVal]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: 0,
    className: "modal-overlay"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-note"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "closeIcon",
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      return props.onClick(e);
    },
    onClick: function onClick(e) {
      return props.onClick(e);
    },
    ref: focusClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)), /*#__PURE__*/_react["default"].createElement(_wbmInputs.TextArea, {
    label: "Note",
    onChange: function onChange(e) {
      return handleChange(e);
    },
    value: inputVal,
    id: "add-note-modal"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "char-remaining"
  }, charLeft, " Characters Remaining"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-note-buttons"
  }, /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "wbm-button btn btn-link cancel-btn",
    onClick: function onClick(e) {
      return props.onClick(e);
    }
  }, "Cancel "), /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "wbm-button btn btn-primary btn-success",
    onClick: function onClick() {
      return handleActionItem();
    }
  }, "Save ")))));
};
//# sourceMappingURL=addNoteModal.js.map